import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../config/api";

export const getTop10Tracks = createAsyncThunk('top10-edits/getTop10Tracks', async ({ token }) => {
    const response = await api.get(
        '/top10-edits/top10',
        {
            token: token,
        },
    );
    return response.data;
});

export const getTop10TracksForYou = createAsyncThunk('top10-edits/getTop10TracksForYou', async ({ token }) => {
    const response = await api.get(
        '/top10-edits/top10foryou',
        {
            token: token,
        },
    );
    return response.data;
});

export const updateTop10Tracks = createAsyncThunk('top10-edits/updateTop10Tracks', async ({ token, supremeEssentials, forYou }) => {
    const response = await api.put(
        '/top10-edits/top10',
        { 
            supremeEssentials, 
            forYou 
        },
        {
            token: token,
        },
    );
    return response.data;
});

export const getAllTracks = createAsyncThunk('top10-edits/getAllTracks',async ({ token, page = 1, limit = 50 }) => {
    const response = await api.get(
        '/top10-edits/tracks',
        {
            token: token,
            params: {

                page,
                limit,
            },
        },
        
    );
    return response.data;
});

export const searchTracks = createAsyncThunk(
    'top10-edits/searchTracks', 
    async ({ token, search, page = 1, limit = 50 }) => {
        const response = await api.get(
            '/top10-edits/search', // Dedicated search endpoint
            {
                token: token,
                params: {
                    search: search, // Changed from 'query' to 'search'
                    page,
                    limit,
                },
            },
        );
        return response.data;
    }
);